'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {};

var ViewApplicationDialog = function (_React$Component) {
  (0, _inherits3.default)(ViewApplicationDialog, _React$Component);

  function ViewApplicationDialog() {
    (0, _classCallCheck3.default)(this, ViewApplicationDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ViewApplicationDialog.__proto__ || (0, _getPrototypeOf2.default)(ViewApplicationDialog)).call(this));

    _this.state = initialState;
    return _this;
  }

  (0, _createClass3.default)(ViewApplicationDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'forceClose',
    value: function forceClose(reason) {
      this.props.onCloseNo(reason);
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.setState(initialState);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      this.props.onCloseNo('Cancelled');
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ViewApplicationDialog.scss');
      var _props$app = this.props.app,
          name = _props$app.name,
          company = _props$app.company,
          icon = _props$app.icon,
          description = _props$app.description,
          id = _props$app.id,
          secret = _props$app.secret;


      return _react2.default.createElement(
        _components.PopupBox,
        null,
        _react2.default.createElement(
          'form',
          { className: styles['Create__form'] },
          _react2.default.createElement(_components.TextInput, { className: styles['Create__form-input'], type: 'text', title: 'Name', value: name, disabled: true }),
          _react2.default.createElement(_components.TextInput, { className: styles['Create__form-input'], type: 'text', title: 'Company', value: company, disabled: true }),
          _react2.default.createElement(_components.TextInput, { className: styles['Create__form-input'], type: 'text', title: 'Icon', value: icon, disabled: true }),
          _react2.default.createElement(_components.TextInput, { className: styles['Create__form-input'], type: 'text', title: 'ID', value: id, disabled: true }),
          _react2.default.createElement(_components.TextInput, { className: styles['Create__form-input'], type: 'text', title: 'Key', value: secret, disabled: true }),
          _react2.default.createElement(
            'div',
            { className: styles['Description__message-label'] },
            'Description'
          ),
          _react2.default.createElement('textarea', { rows: '2', className: styles['Description__message'], value: description, disabled: true }),
          _react2.default.createElement(
            'div',
            { className: styles['CreateApplicationDialog__buttons'] },
            _react2.default.createElement(_components.Button, { primary: true, className: styles['CreateApplicationDialog__button'], label: 'Close', onClick: this.handleCancelClick.bind(this) })
          )
        )
      );
    }
  }]);
  return ViewApplicationDialog;
}(_react2.default.Component);

exports.default = ViewApplicationDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ViewApplicationDialog/ViewApplicationDialog.jsx
// module id = 2477
// module chunks = 0